import React, { useState } from "react";
import moment from "moment";
import Loader from "components/common/Loader/Loader";
import { roleAccess } from "helpers/RolesPermission";
import { USER_ROLE } from "Constants/constant";
import { baseURLImage, getNameProfile, textTruncate } from "Utils/utils";
import { toast } from "react-toastify";
import api from "store/services/participant.services";
import {
  CalendarIcon,
  CheckCircleIcon,
  LocationMarkerIcon,
  RefreshIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import { BiPencil } from "react-icons/bi";
import { HiOutlineEye, HiOutlineTrash } from "react-icons/hi";
import DeleteAppointmentModal from "./DeleteAppointmentModal";
import ViewAppointmentModal from "./ViewAppointmentModal";

const AppointmentItem = (props) => {
  const {
    index,
    meeting,
    setSelectedAppointment,
    setIsOpen,
    participantAppointmentDeleteLocally,
    isUserGracePeriodOver,
    refreshAppointments,
  } = props;

  const [deleteAppointmentLoader, setDeleteAppointmentLoader] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false); // State for view modal

  const handleImageError = (e, fname, lname) => {
    return (e.target.src = getNameProfile(fname, lname));
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case "Canceled":
        return (
          <XCircleIcon className='h-5 w-5 text-red-500' aria-hidden='true' />
        );
      case "Rescheduled":
        return (
          <RefreshIcon className='h-5 w-5 text-yellow-500' aria-hidden='true' />
        );
      case "Completed":
        return (
          <CheckCircleIcon
            className='h-5 w-5 text-green-500'
            aria-hidden='true'
          />
        );
    }
  };

  const getStatusBadge = (status) => {
    const statusConfig = {
      Canceled: "bg-red-100 text-red-700 border-red-200",
      Rescheduled: "bg-yellow-100 text-yellow-700 border-yellow-200",
      Completed: "bg-green-100 text-green-700 border-green-200",
    };
    return statusConfig[status] || "bg-gray-100 text-gray-700 border-gray-200";
  };

  return (
    <li key={`${index}-${meeting.id}`} className='hover:bg-gray-50 transition-colors'>
      <div className='flex items-start justify-between py-4 px-4 sm:px-6'>
        <div className='flex space-x-4 flex-1 min-w-0'>
          <div className='flex-shrink-0'>
            <img
              onError={(e) => handleImageError(e, meeting.name, " ")}
              className='h-10 w-10 rounded-full object-cover ring-2 ring-gray-200'
              src={
                meeting?.profile_picture
                  ? baseURLImage(meeting.profile_picture)
                  : getNameProfile(meeting.name, " ")
              }
              alt='avatar'
            />
          </div>
          <div className='flex-1 min-w-0'>
            <h3
              title={meeting.title}
              className='text-sm font-semibold text-gray-900 truncate'
            >
              {meeting.title}
            </h3>
            <div className='mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-gray-600'>
              <div className='flex items-center space-x-1.5'>
                <CalendarIcon className='h-4 w-4 text-gray-400' aria-hidden='true' />
                <span>
                  {meeting
                    ? `${moment(new Date(meeting.date)).format("DD MMM, YYYY")} at ${meeting.time}`
                    : ""}
                </span>
              </div>
              {meeting.location && (
                <div className='flex items-center space-x-1.5'>
                  <LocationMarkerIcon className='h-4 w-4 text-gray-400' aria-hidden='true' />
                  <span className='truncate'>{meeting.location}</span>
                </div>
              )}
              <div className='flex items-center space-x-1.5'>
                {getStatusIcon(meeting.status)}
                <span className={`px-2 py-0.5 rounded-full text-xs font-medium border ${getStatusBadge(meeting.status)}`}>
                  {meeting.status}
                </span>
              </div>
            </div>
          </div>
        </div>
        {roleAccess([USER_ROLE.Sp_Admin, USER_ROLE.Sp_manager]) && (
          <div className='flex items-center space-x-2 ml-4 flex-shrink-0'>
            <button
              className='p-1.5 rounded-md text-blue-600 hover:bg-blue-50 transition-colors'
              onClick={() => {
                setSelectedAppointment(meeting);
                setIsOpen(true);
              }}
              title='Edit'
            >
              <BiPencil className='h-4 w-4' />
            </button>
            <button
              onClick={() => {
                setOpenViewModal(true);
              }}
              className='p-1.5 rounded-md text-gray-600 hover:bg-gray-50 transition-colors'
              title='View'
            >
              <HiOutlineEye className='h-4 w-4' />
            </button>
            {deleteAppointmentLoader !== null &&
            deleteAppointmentLoader === meeting.id ? (
              <Loader isSmallView cssClass='text-black' />
            ) : (
              <button
                onClick={() => {
                  setOpenDeleteModal(true);
                }}
                className='p-1.5 rounded-md text-red-600 hover:bg-red-50 transition-colors'
                title='Delete'
              >
                <HiOutlineTrash className='h-4 w-4' />
              </button>
            )}
          </div>
        )}
      </div>
      {openDeleteModal && (
        <DeleteAppointmentModal
          open={openDeleteModal}
          setOpen={setOpenDeleteModal}
          isUserGracePeriodOver={isUserGracePeriodOver}
          handleClose={() => setOpenDeleteModal(false)}
          appointmentId={meeting.id}
          refreshAppointments={refreshAppointments}
        />
      )}
      {openViewModal && (
        <ViewAppointmentModal
          open={openViewModal}
          setOpen={setOpenViewModal}
          isUserGracePeriodOver={isUserGracePeriodOver}
          appointment={meeting}
          handleClose={() => setOpenViewModal(false)}
        />
      )}
    </li>
  );
};
export default AppointmentItem;
